import React from 'react';
import { cdn } from '@deporvillage/picture-component';

const IconItems = [
    {
        src: '/static/icons/apple-touch-icon.png',
        sizes: '',
    },
    {
        src: '/static/icons/apple-touch-icon-57x57.png',
        sizes: '57x57',
    },
    {
        src: '/static/icons/apple-touch-icon-72x72.png',
        sizes: '72x72',
    },
    {
        src: '/static/icons/apple-touch-icon-76x76.png',
        sizes: '76x76',
    },
    {
        src: '/static/icons/apple-touch-icon-114x114.png',
        sizes: '114x114',
    },
    {
        src: '/static/icons/apple-touch-icon-120x120.png',
        sizes: '120x120',
    },
    {
        src: '/static/icons/apple-touch-icon-144x144.png',
        sizes: '144x144',
    },
    {
        src: '/static/icons/apple-touch-icon-152x152.png',
        sizes: '152x152',
    },
    {
        src: '/static/icons/apple-touch-icon-180x180.png',
        sizes: '180x180',
    },
];

const MetaIcons = ({ config }) => (
    <>
        <link
            rel='shortcut icon'
            href={`https://${config.cdn.hosts[0]}/static/icons/favicon.ico`}
            type='image/x-icon'
        />
        {
            IconItems.map(({ src, sizes }) => (
                <link
                    key={sizes || 'default'}
                    rel='apple-touch-icon'
                    sizes={sizes || null}
                    href={cdn({ src }, config.cdn)}
                />
            ))
        }
    </>
);

export default MetaIcons;
export { MetaIcons };